import MoreVertIcon from '@mui/icons-material/MoreVert';
import { deleteDoc, doc } from 'firebase/firestore';
import { useState } from 'react';
import db from './firebase';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { useContext } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';

const VideoCommentContent = ({dataSent,user_name,commentText,timestamp,useremail}) => {
    const [menu_options,setMenuOptions]=useState(false);
    const [owner,setOwner]=useState(false);
    const [deleteFailed,setDeletefailed]=useState(false);
   
    const navigate = useNavigate();
    const menuRef = useRef();

    const {user_email} = useContext(AuthContext);
   

    useEffect(()=>{
        if(useremail === user_email){
            setOwner(true);
        }else{
            setOwner(false);
        }
    },[useremail,user_email]);

    useEffect(()=>{
       const handleCloseMenu=(e)=>{
        if(!menuRef.current.contains(e.target)){
            setMenuOptions(false);
        }
       };
       document.addEventListener('mousedown',handleCloseMenu);
       return ()=>{
        document.removeEventListener('mousedown',handleCloseMenu);
       }
    },[]);
    
    const deleteComment=async()=>{
            const doc_ref = sessionStorage.getItem(`${timestamp}`);
            if(doc_ref){
              try{
                  const docu_ref = doc(db,"Video Comments",doc_ref);
                  await deleteDoc(docu_ref);
                  sessionStorage.removeItem(`${timestamp}`);
              }catch{
                      
              }
            }else{
              setDeletefailed(true);
            }
        
    };

    const gotofeedbackpage=()=>{
        navigate("/contact");
    };



    return ( 
        <div  className="vidcommentcontent" key={timestamp}>
           
                <div className="commenthead">
                <svg
                    viewBox="0 0 24 24"
                    fill="#812072"
                    height="30px"
                    width="30px">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z" />
                </svg>
                    {user_name && <p>{user_name}</p>}
                    <span>-</span>
                    {dataSent && <span>{dataSent}</span>}

                   
                    <div onClick={()=>setMenuOptions(prev => !prev)} style={{cursor:"pointer",position:"relative"}} ref={menuRef}>
                        <MoreVertIcon/>
                        {menu_options && 
                        <div className="vidmenuoption">
                        {owner && 
                                 <button style={{backgroundColor:"transparent",border:"none",fontWeight:"bold",cursor:"pointer"}} 
                                 onClick={()=>deleteComment()}>
                                     Delete
                                 </button>
                        }

                        {!owner && 
                                <button style={{backgroundColor:"transparent",border:"none",fontWeight:"bold",cursor:"pointer"}} 
                                onClick={()=>gotofeedbackpage()}>
                                    Report
                                </button>
                        }
                    </div>
                    }
                    </div>
   
                </div>

                <div className="commentbody">
                    {commentText && <pre>{commentText}</pre>}
                </div>

                {deleteFailed && 
                  <div className="toast2">
                  <p style={{color:"white",fontWeight:"bold"}}>
                session expired for document deletion.
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setDeletefailed(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="30px"
                    width="30px">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
                </div>
                }
            
        </div>
     );
}
export default VideoCommentContent;